module.exports = __webpack_public_path__ + "static/media/two.b803c52b.svg";